<template lang="pug">
.content(
  v-loading="loading"
  element-loading-text="数据导入中，请耐心等待..."
  element-loading-spinner="el-icon-loading"
  element-loading-background="rgba(255, 255, 255)")
  .success(v-if="sucess")
    i.el-icon-success
    .tips 完成，本次导入成功{{responseData.success||0}}条数据
    .tips(v-if="responseData.error>0") 导入失败{{responseData.error||0}}条数据
    el-table(border :data="dataTabel" v-if="responseData.error>0")
      el-table-column( v-for="(value,key) in tableHeader" :prop="key" :label="value" :key="key")
</template>

<script>
export default {
  data () {
    return {
      loading: false,
      responseData: "",
      sucess: false,
      errorList: []
    };
  },
  computed: {
    tableHeader() {
      return this.responseData.errorList[0];
    },
    dataTabel() {
      return this.responseData.errorList.filter((item, index) => index !== 0);
    }
  },
  methods: {
    startLoading() {
      this.loading = true;
    },
    isSuccess(val) {
      this.sucess = true;
      this.responseData = val;
      this.loading = false;
    }

  }
};
</script>

<style lang="scss" scoped>
.content{
  width: 100%;
  height: 350px;
}
.success{
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  i{
    font-size: 50px;
    color: #4777E7;
  }
  .tips{
    margin-top: 10px;
  }
}
</style>
